var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('transition',{attrs:{"name":"fade"}},[(_vm.exists)?_c('b-img',{staticClass:"h-100 fit-image top-image",attrs:{"src":_vm.imageLink,"fluid-grow":""}}):_vm._e()],1),_c('b-img',{staticClass:"h-100 fit-image forced-top-left-placement",attrs:{"src":require("@/assets/images/product-image-not-found.jpg"),"fluid-grow":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }